import app from '@/app';
import templateUrl from './solutions-button.html';


  app.component('prSolutionsButton', {
    templateUrl,
    bindings: {
      type: '@',
      state: '@',
      params: '<'
    }
  });
